import { Group } from '@mantine/core';
import { baseWhite, secondaryBase } from '../../../styles/design-tokens';
import { Button } from '../../../ui-library/button/button';
import { Icon } from '../../../ui-library/icon/icon';
import { WorkPeriodsTab } from '../work-periods.type';

interface WorkPeriodTabsProps {
  selectedTab: WorkPeriodsTab;
  setSelectedTab: (tab: WorkPeriodsTab) => void;
}

const iconMap: Record<WorkPeriodsTab, string> = {
  [WorkPeriodsTab.ASSESSMENT]: 'checklist',
  [WorkPeriodsTab.WORK_PHASE_DISTRIBUTION]: 'insights',
  [WorkPeriodsTab.WORK_PACE]: 'speed',
  [WorkPeriodsTab.DELIVERY_CONFIDENCE]: 'trending_up',
  [WorkPeriodsTab.BREAKDOWN]: 'pie_chart',
  [WorkPeriodsTab.COMPARISON_TABLE]: 'table_chart',
  [WorkPeriodsTab.COMPARISON_MEASURE_COMPARISON]: 'insights',
  [WorkPeriodsTab.COMPARISON_MEASURES_OVER_TIME]: 'trending_up',
};

const titles: Record<WorkPeriodsTab, string> = {
  [WorkPeriodsTab.ASSESSMENT]: 'Assessment',
  [WorkPeriodsTab.WORK_PHASE_DISTRIBUTION]: 'Work Phase Distribution',
  [WorkPeriodsTab.WORK_PACE]: 'Work Pace',
  [WorkPeriodsTab.DELIVERY_CONFIDENCE]: 'Delivery Confidence',
  [WorkPeriodsTab.BREAKDOWN]: 'Breakdown',
  [WorkPeriodsTab.COMPARISON_TABLE]: 'Table View',
  [WorkPeriodsTab.COMPARISON_MEASURE_COMPARISON]: 'Measure Comparison',
  [WorkPeriodsTab.COMPARISON_MEASURES_OVER_TIME]: 'Measures Over Time',
};

export const WorkPeriodTabs = ({ selectedTab, setSelectedTab }: WorkPeriodTabsProps) => {
  const isComparisonView =
    selectedTab === WorkPeriodsTab.COMPARISON_TABLE ||
    selectedTab === WorkPeriodsTab.COMPARISON_MEASURE_COMPARISON ||
    selectedTab === WorkPeriodsTab.COMPARISON_MEASURES_OVER_TIME;

  const tabs = isComparisonView
    ? [
        WorkPeriodsTab.COMPARISON_TABLE,
        WorkPeriodsTab.COMPARISON_MEASURE_COMPARISON,
        WorkPeriodsTab.COMPARISON_MEASURES_OVER_TIME,
      ]
    : [
        WorkPeriodsTab.ASSESSMENT,
        WorkPeriodsTab.WORK_PHASE_DISTRIBUTION,
        WorkPeriodsTab.WORK_PACE,
        WorkPeriodsTab.DELIVERY_CONFIDENCE,
        // WorkPeriodsTab.BREAKDOWN, // TODO: Add back in once we have a way to show the breakdown for ad-hoc and test the BE endpoint to be valid
      ];
  return (
    <Group gap="xs">
      {tabs.map((value) => (
        <Button
          key={value}
          size="xs"
          radius="xl"
          variant={value === selectedTab ? 'secondary' : 'outline'}
          onClick={() => setSelectedTab(value)}
          leftSection={
            <Icon
              name={iconMap[value]}
              color={value === selectedTab ? baseWhite : secondaryBase}
              size={16}
              style={{ cursor: 'pointer' }}
            />
          }
        >
          {titles[value]}
        </Button>
      ))}
    </Group>
  );
};
